import {TermsAcceptanceChannel, TermsAcceptanceRecord} from './_models'

const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'

// The legal text writes its numbers in Persian digits; its date and version do the same.
const toPersianDigits = (value: string | number) =>
  String(value).replace(/\d/g, (digit) => PERSIAN_DIGITS[Number(digit)])

const JALALI_MONTHS = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
]

// 1404/07/14 → «۱۴ مهر ۱۴۰۴», the way the rules page on asatsp.ir writes its date.
export const formatTermsDay = (day?: string | null): string => {
  const match = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/.exec(String(day || '').trim())
  if (!match) return toPersianDigits(day || '')
  const month = JALALI_MONTHS[Number(match[2]) - 1]
  if (!month) return toPersianDigits(day || '')
  return `${toPersianDigits(Number(match[3]))} ${month} ${toPersianDigits(match[1])}`
}

export const formatTermsVersion = (version?: number | null) =>
  `نسخه ${toPersianDigits(Number(version || 0))}`

const CHANNEL_LABELS: Record<TermsAcceptanceChannel, string> = {
  prompt: 'هنگام ورود به پنل',
  registration: 'هنگام ثبت کسب‌وکار',
}

export const formatTermsChannel = (channel?: TermsAcceptanceChannel | null) =>
  (channel && CHANNEL_LABELS[channel]) || 'در پنل'

// «۹ مهر ۱۴۰۵، ساعت ۱۴:۳۰»
export const formatTermsAcceptedAt = (record: Pick<TermsAcceptanceRecord, 'day' | 'time'>) =>
  record.time
    ? `${formatTermsDay(record.day)}، ساعت ${toPersianDigits(record.time)}`
    : formatTermsDay(record.day)
